import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Dialog, DialogOverlay, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Menu, X, ArrowUpRight, ArrowLeft, LogOut, History } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";

const ROOMS = [
  { href: "#object", label: "The bracelet", index: "01" },
  { href: "#standalone", label: "Standalone", index: "02" },
  { href: "#reveal", label: "Finishes", index: "03" },
  { href: "#voices", label: "Meet the voices", index: "04" },
  { href: "#connected", label: "Everyday connections", index: "05" },
  { href: "#transmission", label: "Join the waitlist", index: "06" },
];

export const SignalNav = () => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const { user, logout } = useAuth();
  return (
    <>
      <a href="#signal-main" className="signal-skip" data-testid="signal-skip-content">Skip to content</a>
      <header className="signal-nav" data-testid="signal-header">
        <a href="#top" data-testid="signal-logo" aria-label="Ivory Pulse, back to top"><img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Ivory Pulse" className="brand-invert" draggable={false} /></a>
        <nav aria-label="Product" className="signal-nav-links">
          <a href="#object" data-testid="signal-nav-bracelet">The bracelet</a>
          <a href="#voices" data-testid="signal-nav-voices">The voices</a>
          <a href="#transmission" data-testid="signal-nav-waitlist">Join the waitlist <ArrowUpRight size={14} aria-hidden="true" /></a>
        </nav>
        <button ref={triggerRef} type="button" data-testid="signal-menu-toggle" aria-expanded={open} aria-haspopup="dialog" aria-controls="signal-menu-dialog" onClick={() => setOpen(true)}><span>Menu</span><Menu size={20} aria-hidden="true" /></button>
      </header>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogOverlay className="signal-menu-overlay" data-testid="signal-menu-overlay" />
        <DialogPrimitive.Content id="signal-menu-dialog" data-testid="signal-menu" className="signal-menu-dialog" onCloseAutoFocus={(e) => { e.preventDefault(); triggerRef.current?.focus(); }}>
          <DialogTitle className="sr-only">Explore Ivory Pulse</DialogTitle>
          <DialogDescription className="sr-only">Product chapters, company information and account.</DialogDescription>
          <div className="signal-menu-top"><img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Ivory Pulse" className="brand-invert" /><button type="button" onClick={() => setOpen(false)} aria-label="Close menu" data-testid="signal-menu-close"><X size={24} aria-hidden="true" /></button></div>
          <nav aria-label="All chapters" className="signal-menu-chapters">
            {ROOMS.map((r) => <a key={r.index} href={r.href} onClick={() => setOpen(false)} data-testid={`signal-menu-${r.index}`}><span>{r.label}</span><ArrowUpRight size={22} aria-hidden="true" /></a>)}
          </nav>
          <div className="signal-menu-pages">
            {["Company", "Contact", "Terms", "Privacy"].map((label) => <Link key={label} to={`/${label.toLowerCase()}`} onClick={() => setOpen(false)} data-testid={`signal-menu-page-${label.toLowerCase()}`}>{label}</Link>)}
            {user?.can_view_access_history && <Link to="/admin/access-history" onClick={() => setOpen(false)} data-testid="signal-menu-access-history" className="inline-flex items-center gap-2"><History size={15} aria-hidden="true" />Istoric acces</Link>}
            <button type="button" onClick={logout} data-testid="signal-menu-logout"><LogOut size={15} aria-hidden="true" /> Sign out</button>
          </div>
          <div className="signal-menu-bottom"><Link to="/" onClick={() => setOpen(false)} data-testid="signal-exit-concept"><ArrowLeft size={15} aria-hidden="true" /> Home</Link><span data-testid="signal-menu-date">Presale · Coming soon</span></div>
        </DialogPrimitive.Content>
      </Dialog>
    </>
  );
};